// main.js
import Vue from 'vue';

export const notify = {
    success,
    error,
    toast,
    confirm
}
    
function success(title,position = "top-end", timer = true) {
    Vue.swal({
        position,
        icon: "success",
        title,
        showConfirmButton: false,
        timer: timer ? 1000 : '',
        timerProgressBar: true,
    });
}
function error(title,position = "top-end", timer = true) {
    Vue.swal({
        position,
        icon: "error",
        title,
        showConfirmButton: false,
        timer: timer ? 1000 : '',
        timerProgressBar: true,
    });
}
function toast(title,position = "bottom", success = true) {
    Vue.swal({
        toast:true,
        position,
        icon: success ? 'success' : 'error',
        title: `<span class='text-light'>${title}</span>`,
        iconColor: 'white',
        timerProgressBar: true,
        background: '#34c336',
        showConfirmButton: false,
        timer: 1500,
    });
}

function confirm() {
   
}